import PrintIcon from "@mui/icons-material/Print";
import { IconButton, Tooltip } from "@mui/material";
import PrintableQRCodes from "components/Pickups/PrintableQRCodes";
import Printable from "components/Printable";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Inventory } from "types/inventory";

export const PrintLabelButton = ({ inventory }: { inventory?: Inventory }) => {
  const printComponentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({ contentRef: printComponentRef });

  return (
    <>
      <Tooltip title="Reprint label" disableInteractive>
        <IconButton color="primary" onClick={() => handlePrint()}>
          <PrintIcon />
        </IconButton>
      </Tooltip>
      <Printable>
        <PrintableQRCodes ref={printComponentRef} selectedInventories={inventory ? [inventory] : []} />
      </Printable>
    </>
  );
};
